import {
	REFRESH_STATES,
  SET_STATES,
  SET_ADVANCED
} from './types';

export const setRefreshStates = () => {
	return {
    type: REFRESH_STATES,
    payload: [],
  };
}

export const setStates = (params) => {
	return {
    type: SET_STATES,
    payload: params,
  };
}

export const setIsAdvance = (params) => {
  return {
    type: SET_ADVANCED,
    payload: params,
  };
}